import { VenueCard } from "./VenueCard";

export default VenueCard;
